import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { NumericFormat } from 'react-number-format';

import { IconWrapper } from 'components/Icon';
import { maxRate } from '../utils/rates';

export const RateInput = ({ label, value, excluded, onSave }) => {
  const theme = useTheme();
  const savedValue = value ?? null;
  const [draft, setDraft] = useState(savedValue);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => setDraft(savedValue), [savedValue]);

  const save = () => {
    if (draft === savedValue) return;
    if (draft === 0) {
      setDraft(savedValue);
      return;
    }

    setIsSaving(true);
    onSave(draft)
      .catch(() => setDraft(savedValue))
      .finally(() => setIsSaving(false));
  };

  if (excluded) {
    return (
      <Box position="relative" m={0.75}>
        <TextField
          size="small"
          disabled
          inputProps={{ 'aria-label': `${label} (excluded)` }}
          sx={{ width: 120 }}
        />
        <IconWrapper
          icon="xMark"
          aria-hidden
          height={18}
          position="absolute"
          top="50%"
          left="50%"
          display="flex"
          sx={{
            svg: {
              width: 18,
              height: 18,
              color: theme.palette.text.disabled,
              stroke: theme.palette.text.disabled,
            },
          }}
          style={{ transform: 'translate(-50%, -50%)', pointerEvents: 'none' }}
        />
      </Box>
    );
  }

  return (
    <NumericFormat
      customInput={TextField}
      size="small"
      value={draft ?? ''}
      onValueChange={({ floatValue }) => setDraft(floatValue ?? null)}
      onBlur={save}
      onKeyDown={(event) => event.key === 'Enter' && event.target.blur()}
      isAllowed={({ floatValue }) => floatValue === undefined || floatValue <= maxRate}
      decimalScale={2}
      allowNegative={false}
      thousandSeparator=" "
      decimalSeparator=","
      allowedDecimalSeparators={[',', '.']}
      disabled={isSaving}
      inputProps={{ 'aria-label': label, inputMode: 'decimal' }}
      sx={{ width: 120, m: 0.75, '& input': { textAlign: 'right' } }}
    />
  );
};
